import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-forecasts',
  templateUrl: './forecasts.component.html',
  styleUrls: ['./forecasts.component.css']
})
export class ForecastsComponent implements OnInit {
    public itemsListForecasts: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadForecasts(): Promise<void> {
        this.itemsListForecasts = await this.datatask.Post(855);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'forecast':
                this.stateService?.go('forecast', { forecast_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadForecasts();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('forecasts', {
//        templateUrl: 'views/components/views/forecasts/forecasts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'forecastsService', function (stateService, forecastsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListForecasts: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCION CALL

//            async function loadForecasts() {
//                vm.model.itemsListForecasts = (await forecastsService.listForecasts());
//            }

//            // #endregion LOAD PROCEDURE FUNCION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'forecast':
//                        go({ forecast_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadForecasts();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
